<template>
  <div class="page-container no-margin-top">
    Error
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Error',
  components: {}
});
</script>
